export const PROD_CONFIG = {
  KUNGFU_CONTRACT: "0x5ba1ae724047add7797a2efdcab8fc5a0b8dc29e",
  NET_ID: 1, // MAIN
  BAYC_ARRD: "0xBC4CA0EdA7647A8aB7C2061c2E118A18a936f13D",
  MEEBITS_ADDR: "0x7Bd29408f11D2bFC23c34f18275bBf23bB716Bc7",
};

export const TEST_CONFIG = {
  // KUNGFU_CONTRACT: "0xFB6C9bF101c66D8726Efa76fa3fC36ea07dF6993",
  // KUNGFU_CONTRACT: "0xf13F1B81B747E18897ABb855729F1ec4C3a61955",
  KUNGFU_CONTRACT: "0x67e705dd91A7132315Df0E7F812E4e9887E9C1E2",
  NET_ID: 4, // Rinkeby
  BAYC_ARRD: "0x6949a9279651d4cf8da4cb31b14dba2faad61f39",
  MEEBITS_ADDR: "0xefda1aeec0ccbf42e4101505b34a1f0c1382bd7f",
};

export const PROD_OPENTIME = {
  openSale: 1625932800000,
  gallery: 1626364800000,
  grant: 1625932800000,
  // game: 1626107400000, // 0713 0030
  game: 1628179200000, // 0714 0030
  // game: 1626106930000,
};

export const TEST_OPENTIME = {
  openSale: 1625932800000,
  gallery: 1626364800000,
  grant: 1625932800000,
  game: 1628179200000,
};

// const

export const GAME_TIME_CONFIG = [
  {
    type: 1,
    number: "1 - 2",
    coldDownTime: 3 * 60,
  },
  {
    type: 1,
    number: "3 - 5",
    coldDownTime: 2 * 60,
  },
  {
    type: 1,
    number: "6 - 10",
    coldDownTime: 1 * 60,
  },
  {
    type: 1,
    number: "11 - 20",
    coldDownTime: 50,
  },
  {
    type: 1,
    number: "21 - 30",
    coldDownTime: 40,
  },
  {
    type: 1,
    number: "30",
    coldDownTime: 30,
  },
  {
    type: 2,
    number: "other",
    coldDownTime: 5 * 60,
  },
];
